export default __webpack_public_path__ + "static/media/image-speakers.bbb1a70b.png";